<template>
  <div>
    <label class="control-label">{{ labelText || name }}</label>
    <p v-if="instructions" v-html="instructions" class="piece-instructions"></p>
    <input :id="inputId" type="hidden" :class="'form-control ' + name" :name="name" :value="cleanedContent" />

    <code-editor
      :id="editorId"
      :content="cleanedContent"
      @content-change="onContentChange($event)"
      class="w-100 mb-4"
    ></code-editor>
  </div>
</template>

<script>
import CodeEditor from '../../../../components/editor/CodeEditor';
import utils from '../../../../mixins/utils';

export default {
  name: 'step-script-input',
  components: {CodeEditor},
  mixins: [utils],
  props: {
    content: {
      type: String,
      required: true,
    },
    instructions: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cleanedContent() {
      return this.stripSlashes(this.content);
    },
    editorId() {
      return `code-editor-${this.stepId}-${this.name}`;
    },
    inputElement() {
      return document.querySelector(`input#${this.inputId}`);
    },
    inputId() {
      return `step-${this.stepId}-input-${this.name}`;
    },
  },
  methods: {
    onContentChange(content) {
      this.inputElement.value = content;
      this.$emit('update', content);
    },
  },
};
</script>
